<template>
  <div>
    <b-row>
      <b-col>
        <b-card
          class="card-dashboard mb-2 pointer"
          :class="active === 'Summary HmEwh' ? 'bg-color' : ''"
          @click="onClick('Summary HmEwh')"
        >
          <div class="d-flex justify-content-rounded top-item mb-2">
            <img src="@/assets/dashboard-hm.svg" width="35" height="35">
            <div class="flex-fill text-center">{{ summary.count_summary_HmEwh }}</div>
          </div>
          <div class="bottom-item text-truncate">Summary HM &amp; EWH</div>
        </b-card>
      </b-col>
      <b-col>
        <b-card
          class="card-dashboard mb-2 pointer"
          :class="active === 'Summary Progress' ? 'bg-color' : ''"
          @click="onClick('Summary Progress')"
        >
          <div class="d-flex justify-content-rounded top-item mb-2">
            <img src="@/assets/dashboard-progress.svg" width="35" height="35">
            <div class="flex-fill text-center">{{ summary.count_summary_progress }}</div>
          </div>
          <div class="bottom-item text-truncate">Summary Progress</div>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="card-dashboard mb-2 pointer"
        :class="active === 'Rental Equipment' ? 'bg-color' : ''"
        @click="onClick('Rental Equipment')"
      >
          <div class="d-flex justify-content-rounded top-item mb-2">
            <img src="@/assets/dashboard-bup.svg" width="35" height="35">
            <div class="flex-fill text-center">{{ summary.count_backup_payment }}</div>
          </div>
          <div class="bottom-item text-truncate">Rental Equipment</div>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="card-dashboard mb-2 pointer"
        :class="active === 'PAF' ? 'bg-color' : ''"
        @click="onClick('PAF')"
      >
          <div class="d-flex justify-content-rounded top-item mb-2">
            <img src="@/assets/dashboard-pay-auth.svg" width="35" height="35">
            <div class="flex-fill text-center">{{ summary.count_payment_auth }}</div>
          </div>
          <div class="bottom-item text-truncate">Payment Authorization</div>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="card-dashboard mb-2 pointer"
        :class="active === 'Waiting' ? 'bg-color' : ''"
        @click="onClick('Waiting')"
      >
          <div class="d-flex justify-content-rounded top-item mb-2">
            <img src="@/assets/dashboard-revise.svg" width="35" height="35">
            <div class="flex-fill text-center">{{ summary.count_revised }}</div>
          </div>
          <div class="bottom-item text-truncate">On Progress</div>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="card-dashboard mb-2 pointer"
        :class="active === 'Approved' ? 'bg-color' : ''"
        @click="onClick('Approved')"
      >
          <div class="d-flex justify-content-rounded top-item mb-2">
            <img src="@/assets/dashboard-approve.svg" width="35" height="35">
            <div class="flex-fill text-center">{{ summary.count_approved }}</div>
          </div>
          <div class="bottom-item text-truncate">Approved</div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    summary: {
      types: Object,
      default: () => ({})
    },
    reset: {
      types: Boolean,
      default: () => false
    }
  },
  watch: {
    'reset'(value) {
      if (value) {
        this.active = ''
      }
    }
  },
  data: () => ({
    active: ''
  }),
  methods: {
    onClick(value) {
      this.active = value
      this.$emit('filter', value)
    }
  }
}
</script>
